import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import * as paths from './paths';
import {
  Entrance,
  Interface,
  Intro,
  Loading,
  NoCamera,
  NoPermission,
  NotFound,
  NoTimeLeft,
  Root,
  Success,
  TryAgain,
  Waiting,
  Error,
  Linked,
} from './components';

export const Routes = () => {
  return (
    <Switch>
      <Route exact path={paths.PATH_ROOT}>
        <Root/>
      </Route>
      <Route exact path={`${paths.PATH_ROOT}${paths.PATH_LOADING}`}>
        <Loading/>
      </Route>
      <Route exact path={`${paths.PATH_ROOT}${paths.PATH_ERROR}`}>
        <Error/>
      </Route>
      <Route exact last path={`${paths.PATH_ROOT}${paths.PATH_INTRO}`}>
        <Intro/>
      </Route>
      <Route exact path={`${paths.PATH_ROOT}${paths.PATH_WAITING}`}>
        <Waiting/>
      </Route>
      <Route exact path={`${paths.PATH_ROOT}${paths.PATH_LIVENESS}`}>
        <Interface/>
      </Route>
      <Route exact path={`${paths.PATH_ROOT}${paths.PATH_NO_CAMERA}`}>
        <NoCamera/>
      </Route>
      <Route exact path={`${paths.PATH_ROOT}${paths.PATH_NO_PERMISSION}`}>
        <NoPermission/>
      </Route>
      <Route exact path={`${paths.PATH_ROOT}${paths.PATH_NO_TIME_LEFT}`}>
        <NoTimeLeft/>
      </Route>
      <Route exact path={`${paths.PATH_ROOT}${paths.PATH_SUCCESS}`}>
        <Success/>
      </Route>
      <Route exact path={`${paths.PATH_ROOT}${paths.PATH_TRY_AGAIN}`}>
        <TryAgain/>
      </Route>
      <Route exact path={`${paths.PATH_ROOT}${paths.PATH_LINKED}`}>
        <Linked />
      </Route>
      <Route exact path={`${paths.PATH_ROOT}:projectId/:backendURL`}>
        <Entrance/>
      </Route>
      <Redirect to={`${paths.PATH_ROOT}`} />
    </Switch>
  );
};
